(() => {
  const init = () => {
    const header = document.querySelector('[data-site-header]');
    const toggle = header?.querySelector('.header-shop__toggle');
    const menu = header?.querySelector('#ShopMegaMenu');
    const hamburger = header?.querySelector('[data-site-header-toggle]');
    const backdrop = header?.querySelector('[data-shop-backdrop]');
    if (!toggle || !menu || header.dataset.megaReady) return;
    header.dataset.megaReady = 'true';
    const setOpen = open => {
      toggle.setAttribute('aria-expanded', String(open));
      menu.hidden = !open;
      backdrop.hidden = !open;
      if (open) backdrop.style.top = `${header.getBoundingClientRect().bottom}px`;
      header.classList.toggle('site-header--shop-open', open);
    };
    toggle.addEventListener('click', () => setOpen(menu.hidden));
    toggle.addEventListener('keydown', event => {
      if (event.key === 'ArrowDown' || event.key === 'Tab' && !event.shiftKey && !menu.hidden) {
        event.preventDefault(); setOpen(true); menu.querySelector('a').focus();
      }
    });
    backdrop.addEventListener('click', () => setOpen(false));
    document.addEventListener('click', event => {
      if (!menu.hidden && !menu.contains(event.target) && !toggle.contains(event.target) && !hamburger?.contains(event.target)) setOpen(false);
    });
    document.addEventListener('keydown', event => {
      if (event.key === 'Escape' && !menu.hidden) {setOpen(false); (toggle.offsetParent ? toggle : header.querySelector('[data-site-header-toggle]')).focus();}
    });
    document.addEventListener('focusin', event => {
      if (!menu.hidden && !header.contains(event.target)) setOpen(false);
    });
    menu.querySelectorAll('a').forEach(link => link.addEventListener('click', () => setOpen(false)));
    matchMedia('(min-width: 900px)').addEventListener('change', () => setOpen(false));
  };
  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
